// uuid wrapper. It has been created in order to mock uuid in unit tests
import { v4 } from "uuid";

const uuid = {
  generate: v4
};
export default uuid;
